import {
  Stack,
  SxProps,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material'
import { ReactComponent as ArrowDownIcon } from '@shared/assets/arrow-down.svg'
import { ReactComponent as ArrowUpIcon } from '@shared/assets/arrow-up.svg'

import {
  StyledFundStatsWrapper,
  StyledStatsContainer,
  StyledStatCard,
} from './styled'

interface FundStat {
  value: string
  label: string
  date?: string
  increase?: string
  decrease?: string
}

interface IProps {
  sx?: SxProps
  stats?: FundStat[]
  updateDate?: string
  showUpdateDate?: boolean
}

export function FundStatsBanner({ sx, stats }: IProps) {
  // Default data if no stats provided
  const defaultStats: FundStat[] = [
    {
      value: '0.9563',
      label: 'PIAE (EUR)',
      date: '31.12.2025',
      increase: '+0.18%',
    },
    {
      value: '0.6897',
      label: 'PIAC (Kč)',
      date: '31.12.2025',
      decrease: '-0.96%',
    },
    {
      value: '4.104',
      label: 'VIAE (EUR)',
      date: '31.12.2025',
      decrease: '-4.58%',
    },
    {
      value: '7.2M',
      label: 'AUM (EUR)',
      date: '31.12.2025',
      decrease: '-2.81%',
    },
  ]

  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'))

  const fundStats = stats || defaultStats

  return (
    <StyledFundStatsWrapper sx={sx}>
      <StyledStatsContainer maxWidth="lg">
        {fundStats.map((stat, index) => {
          const percentageChange = stat.increase || stat.decrease
          const isIncrease = !!stat.increase

          return (
            <StyledStatCard key={index}>
              <Stack direction="row" alignItems="center" gap={1}>
                <Typography variant={isDesktop ? 'h3' : 'subtitle22'}>
                  {stat.value}
                </Typography>

                {percentageChange && (
                  <Typography
                    variant="text16Regular"
                    color={isIncrease ? '#34C759' : '#F44336'}
                    display="flex"
                    alignItems="center"
                    gap={'6px'}
                  >
                    {isIncrease && <ArrowUpIcon />}
                    {!isIncrease && <ArrowDownIcon />}
                    {percentageChange}
                  </Typography>
                )}
              </Stack>

              <Typography variant="text18Regular">{stat.label}</Typography>

              <Typography variant="text18Regular" color="text.secondary">
                As at {stat.date}
              </Typography>
            </StyledStatCard>
          )
        })}
      </StyledStatsContainer>
    </StyledFundStatsWrapper>
  )
}
